import moment from 'moment'

export const mailManagement = {
    id: '',
    module: '',
    action: '',
    subject: '',
    body: '',
    footer: '',
}

export const mailManagementDetail = {
    id: '',
    mailManagementId: '',
    email: '',
    type: ''
}